// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"SuspenseWithFlag_fallbackContainer__CHfN0","childrenContainer":"SuspenseWithFlag_childrenContainer__TgVRT"};